export default __webpack_public_path__ + "static/media/ashley-johnson.bf5fb43b.jpg";